module.exports = __webpack_public_path__ + "static/media/arrow_right_icon.0c7feac7.svg";